import { useEffect, useState } from 'react';
import PaymentDialogComponent from 'src/pages/payment/payment-dialog.component';
import HttpServices from 'src/services/httpService';
import { paymentModuleUrl } from 'src/services/urlService';

const PlanPaymentComponent = ({ planId, amount, currencySymbol, upgradeItems, handlePaymentDialog, planName, enableAutoPay }) => {
  const [clientSecret, setClientSecret] = useState('');
  const [payableAmount, setPayableAmount] = useState(amount);

  useEffect(() => {
    createPaymentLink();
  }, []);
  
  const successCallback = (data, message) => {
    setClientSecret(data.payment_intent);
    if (data.converted_amount) {
      setPayableAmount(Number(data.converted_amount) / 100);
    }
  }
  const createPaymentLink = () => {
    let paymentForm = {
      new_plan_id: planId,
      add_ons: upgradeItems,
      enable_auto_pay: Boolean(enableAutoPay),
    };
    let postProps = {
      url: paymentModuleUrl.createPayment,
      body: paymentForm,
      successCallback
    }
    HttpServices.Post(postProps);
  };
  return (
    clientSecret && <PaymentDialogComponent clientSecret={clientSecret} amount={payableAmount} planName={planName} currencySymbol={currencySymbol} handleClose={handlePaymentDialog} />
  );
}
export default PlanPaymentComponent;
